<template>
  <div class=sdk>
    <h1>SDK合规使用指南</h1>
    <p>为帮助使用xxx SDK的开发运营者（以下简称“您”）在符合个人信息保护相关法律法规、政策及标准的规定下合规接入、使用第三方SDK， xxx （以下简称"我们"）特制定《PerfSight SDK接入使用说明文档》（以下简称“文档”），便于您使用PerfSight SDK 过程中符合相应的合规要求。请您在接入、使用xxx SDK前，充分阅读和了解本文档内容。</p>

    <h2>一、接入/升级至满足监管新规的最新SDK版本</h2>
    <p>我们高度重视SDK的功能优化、个人信息安全和保护，将适时升级迭代SDK版本以提升产品的安全性和稳定性，确保符合相关法律法规及、监管及标准的最新合规要求。强烈建议您升级使用最新版本SDK，以便保障您正常使用SDK最新功能、避免因您更新不及时产生的不利影响（例如APP被通报或下架等）。 SDK更新后，我们会及时通过官网通知的方式提醒您更新的内容，以便您及时了解SDK最新版本信息。同时，您可以通过邮件联系我们获取SDK最新版本。</p>

    <h2>二、APP隐私政策中应披露第三方SDK相关情况</h2>
    <p>请您确保您开发或运营的APP配备了符合监管要求的《隐私政策》文本。请您务必明确告知终端用户您的App集成了第三方SDK服务。您应在《隐私政策》中添加关于本SDK收集使用个人信息的目的、方式和范围等，并显示本SDK的开发运营者名称及隐私政策链接。您应在 APP 登录注册页面及 APP 首次运行时，通过弹窗、文本链接及附件等简洁明显且易于访问的方式，应当以清晰易懂的语言告知用户《隐私政策》，由用户在充分知情的前提下，作出自愿明确的意思表示。</p>
    <p>我们提供以下告知文案示例供您参考，您可以通过文字或表格方式向用户告知。请您理解SDK不同版本提供的功能服务及所需的字段信息可能会因开发者的选择或配置不同而存在差异，因此请您参考SDK隐私政策及您实际接入使用的SDK运行情况向用户进行充分告知并获得用户的同意。</p>
    <p>第三方SDK名称：xxx Android SDK</p>
    <p>第三方SDK提供方的公司名称：xxx有限公司</p>
    <p>使用目的及功能场景：创建并进行音视频通话</p>
    <p>实现SDK产品功能所需的权限：网络及Wifi状态访问权限</p>
    <p>第三方SDK隐私政策链接： <a href="https://perfsight.qq.com/policy">https://perfsight.qq.com/policy</a></p>
    <p>第三方SDK官网链接： <a href="https://perfsight.qq.com/">https://perfsight.qq.com/</a></p>
    <p>处理方式：去标识化、加密传输的安全处理方式</p>
    <p>第三方SDK名称：PerfSight iOS SDK </p>
    <p>第三方SDK提供方的公司名称：深圳市腾讯计算机系统有限公司</p>
    <p>使用目的及功能场景：收集并上报玩家在游戏过程中的FPS、CPU、内存、流量、网络数据及其他自定义业务层数据 处理的个人信息类型：IDFV、设备型号、openID、Wifi状态、操作系统版本</p>
    <p>实现SDK产品功能所需的权限：无</p>
    <p>第三方SDK隐私政策链接：<a href="https://perfsight.qq.com/policy">https://perfsight.qq.com/policy</a></p>
    <p>第三方SDK官网链接：<a href="https://perfsight.qq.com/">https://perfsight.qq.com/</a></p>
    <p>处理方式：去标识化、加密传输的安全处理方式</p>

    <h2>三、获得用户同意后再初始化SDK</h2>
    <p>P为满足法律法规及监管要求，您应确保在获得用户的同意后再初始化SDK，并在用户触发SDK具体功能服务后通过配置SDK的相关参数完成发送请求的调用，此时SDK才会按照您设置的配置方式采集功能所需的个人信息或申请功能所需的权限。1、 确保在用户阅读APP隐私政策并取得用户授权之后，按APP功能需要在合适时机调用initContext接口初始化PerfSight SDK。反之，如果用户不同意《隐私政策》授权，则不能调用初始化接口。2、 请勿在用户同意隐私政策之前动态申请涉及用户个人信息的敏感设备权限；请勿在用户同意隐私政策前私自采集和上报个人信息（尤其注意Android_ID、OAID、IMEI、MAC地址、硬件序列号、应用安装列表等用户信息）。请勿在App处于未激活状态时（例如App在后台运行），请求SDK相关服务。</p>

    <h2>四、可选信息配置开关</h2>
    <p>SDK向您提供了可选个人信息及权限的控制开关，您可以根据APP所需的SDK功能服务自行配置打开或关闭隐私信息请求开关。</p>
    <h3>1、配置可选个人信息</h3>
    <p>请您注意，SDK不强制获取可选参数，即使没有获取可选参数，SDK提供的基本功能也能正常运行。您可以调用SetUserId接口，设置玩家ID，以便使用SDK查看玩家维度的性能数据。建议调用请求前在合适的时机调用SDK提供的方法，在用户授权的情况下由业务自主获取玩家ID并通过接口传递给PerfSight SDK, 查看接入指南详细操作指引。</p>
    <h3>2、指导建议</h3>
    <p>请您重点关注，在APP安装、运行和使用相关功能时，您应遵从国家相关法律法规、监管政策及标准的要求，收集用户个人信息或申请敏感权限，不得存在以下违规行为：</p>
    <p>（1）未经用户同意不得收集任何个人信息。</p>
    <p>（2）非服务所必需或无合理应用场景下，用户拒绝相关授权申请后，应用不得自动退出或关闭。</p>
    <p>（3）在用户明确拒绝权限申请后，APP不应向用户频繁弹窗或反复申请开启与当前服务场景无关的权限、影响用户正常使用，建议掌握合适时机申请敏感权限，不得影响其他功能可用。</p>
    <p>（4）不得未明确告知用户索取权限的目的和用途。</p>
    <p>（5）APP首次打开或运行中，未见使用权限对应的相关功能或服务时，不应提前向用户弹窗申请开启敏感权限。</p>
    <p>（6）不得超出业务功能实际需要过度收集个人信息。</p>

    <h2>五、用户权利保障机制</h2>
    <p class="bold">本SDK提供以下接口配置，以便您帮助终端用户实现个人信息主体权利请求。</p>
    <p>1、终端用户请求查阅、复制其个人信息时，您可通过访问PerfSight官网联系SDK团队的方式查看本SDK采集的个人信息、获取本SDK采集的用户个人信息副本。</p>
    <p>2、终端用户撤销同意处理其个人信息的授权时，您可通过访问PerfSight官网联系SDK团队的方式停止使用SDK功能并停止采集与关闭功能相应的用户数据。</p>
    <p>3、终端用户请求删除其个人信息时，您可通过访问PerfSight官网联系SDK团队的方式删除采集、上报到本SDK服务端的用户个人信息。</p>
    <p>4、如果您需要我们协助来实现您最终用户的其他个人信息主体权利请求，您可以通过“联系方式”来申请协助。</p>

    <h2>六、注意事项</h2>
    <h3>1、您接入PerfSight SDK前的合规自查</h3>
    <p>为确保您就本SDK的使用获得终端用户的授权，且遵守个人信息保护要求和合规流程，我们建议您在接入PerfSight SDK前进行合规自查。</p>
    <p>1）请仔细阅读并按本说明文档提示对您APP的《隐私政策》进行合规自查。</p>
    <p>2）请务必做延迟初始化配置，确保获得用户同意后再初始化SDK。</p>
    <p>3）当PerfSight SDK基于最新的法律法规或监管要求进行更新后，请您在收到版本更新通知时及时将您APP集成的PerfSight SDK升级到最新版本。</p>
    <p>4）其他国家相关法律法规、监管政策及标准的要求。</p>
    <h3>2、以下合规文件供开发者参考</h3>
    <p>（1）《个人信息保护法》</p>
    <p>（2）《工业和信息化部关于进一步提升移动互联网应用服务能力的通知》</p>
    <p>（3）《工业和信息化部关于开展信息通信服务感知提升行动的通知》</p>
    <p>（4）《工业和信息化部关于开展纵深推进APP侵害用户权益专项整治行动的通知》</p>
    <p>（5）《工业和信息化部关于开展APP侵害用户权益专项整治工作的通知》</p>
    <p>（6）《App违法违规收集使用个人信息行为认定方法》</p>
    <p>（7）《网络安全标准实践指南—移动互联网应用程序(App)收集使用个人信息自评估指南》</p>
    <p>（8）《常见类型移动互联网应用程序必要个人信息范围规定》</p>
    <p>（9）《GB/T 35273-2020信息安全技术 个人信息安全规范》</p>
    <p>（10）《网络安全标准实践指南—移动互联网应用程序（App）使用软件开发工具包（SDK）安全指引》</p>
    <p>（11）《网络安全标准实践指南—移动互联网应用程序（App）系统权限申请使用指南》</p>
  </div>
</template>

<script>
export default {
  name: "sdk",
};
</script>

<style scoped lang="less"></style>
